import React, { useState } from "react";
import "./index.css";
import External from "./components/ExternalUser";
import { AuthenticateDocument } from "./utils/AuthenticateDocument";
import MainLayout from "./components/MainLayout";

function App({ isExternal }) {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  
  return (
    <div className='App'>
      {isExternal ? (
        <External />
      ) : isAuthenticating ? (
        <AuthenticateDocument setIsLoading={setIsAuthenticating} />
      ) : (
        <MainLayout />
      )}
    </div>
  );
}

export default App;
